<script>
import axios from "axios";
import router from "@/router";
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import Swal from "sweetalert2";
import moment from 'moment';
export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  components: { /*logoutButton ,*/ Header , Footer},
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      submitData:{
        user_type_id:'',
        status: "applicant"
      },
    categories:[],
    roles:[],
    role_ids:[],
    availableRoles:{},  
    userTypeId: null,
    userName: null,
    userId: null,
    assignedRoles:{},
    isLoading:false,
    noRecord: false,
    userData : JSON.parse(localStorage.getItem('web_user')),
    reScheduleRequestForm:{
      userId:this.userId,
      role:null,
      building:null,
      location:null,
      time:null,
      date:null,
      comment:null
    },
    requestformData:{
        id:null,
        name:'',
        request_start_date:'',
        request_end_date:'',
        time_slots: {
          'monday':{
            'is_checked':false,
            'time':'',
          },
          'tuesday':{
            'is_checked':false,
            'time':''
          },
          'wednesday':{
            'is_checked':false,
            'time':''
          },
          'thursday':{
            'is_checked':false,
            'time':''
          },
          'friday':{
            'is_checked':false,
            'time':''
          },
          'saturday':{
            'is_checked':false,
            'time':''
          },
        },
        selectedSlots:[],
    },
    contactInfoForm: {
      username: "",
      status: "",
      avatar: "",
      t_shirt: "",
      email: "",
      address: "",
      phone: "",
      city: "",
      state: "",
      zip_code: "",
      age: "",
      gender: "",
      DOB: "",
      address2:"",
      mobile:""
    },
    roleFilterForm:{
      role_id : null,
      category_id:null,
      start_date:null,
      end_date:null,
    },
    sendRoleRequestData:{
      user_id:null,
      role_ids:null,
    }

    }
  },
  mounted(){
    this.userId = this.userData.id;
    // this.getAssignedRoles();
    // this.getContactDetail();
    this.filterAvailableRoles();
  },
  methods: {
    // getContactDetail() {
    //   var token = this.userData.token;
    // //   var token = localStorage.getItem('token');
    //   var config = {
    //     headers: {Authorization: 'Bearer '+token}
    //   };
    //   if (token){
    //     axios.get('user/'+this.userId,config)
    //         .then((res) => {
    //           if (res.status == 200){
    //               console.log(res.data.response);
    //             this.contactInfoForm = res.data.response
    //             this.userName = this.contactInfoForm.username;
    //             // this.contactInfoForm.age = this.calculateAge(res.data.response.DOB);
    //             // this.contactInfoForm.DOB = moment(res.data.response.DOB,'DD/MM/YYYY').format('YYYY-MM-DD');
    //           }
    //         })
    //         .catch((err) => {
    //           if (err.response) {
    //             console.log(err.response.data.error.message)
    //             if (err.response.status == 401) {
    //               this.logout();
    //             }
    //           }
    //         })
    //   }
    // },

    // getAssignedRoles(){
    //   this.isLoading = true;
    //   this.noRecord = false;
    //   var config = {
    //       headers: {
    //         Authorization: 'Bearer ' + this.userData.token,
    //         'Accept': 'application/json'
    //       }
    //     };
    //   axios.get('schedule/users/assignment/'+ this.userId,config).then(res =>{
    //     this.assignedRoles = res.data.response;
    //     console.log(this.assignedRoles)
    //     this.isLoading = false;
    //     if (!this.assignedRoles.length){
    //       this.noRecord = true;
    //     }
    //   }).catch((err) => {
    //     if (err.response) {
    //       if (err.response.status == 404) {
    //         this.noRecord = true;
    //         this.isLoading = false;
    //       }
    //       if (err.response.status == 401) {
    //         this.logout();
    //       }
    //     }
    //   })
    // },
    filterAvailableRoles(){

      let filter = '?location_id='+ this.userData.location_id;
      if (this.roleFilterForm.role_id){
        filter += '&role_id='+ this.roleFilterForm.role_id
      }
      if (this.roleFilterForm.category_id){
        filter += '&category_id='+ this.roleFilterForm.category_id
      }
      if (this.roleFilterForm.start_date && this.roleFilterForm.end_date){
        
        filter += '&start_date='+ this.roleFilterForm.start_date;
        filter += '&end_date='+ this.roleFilterForm.end_date;
      }
        console.log(this.roleFilterForm.start_date);
        console.log(this.roleFilterForm.end_date);

        var config = {
            headers: {
              Authorization: 'Bearer ' + this.userData.token,
              'Accept': 'application/json'
            }
          };
        axios.get('roles_by_filters'+ filter,config).then(res =>{
          this.availableRoles = res.data.response.roles;
          this.roles = [];
          res.data.response.role_options.forEach(role=>{
            this.roles.push({value:role.id ,text:role.name});
          });
          this.categories=[];
          res.data.response.category_options.forEach(category=>{
            this.categories.push({value:category.id ,text:category.name});
          })

          this.availableRoles.forEach((role,index)=>{

            try {
            this.availableRoles[index].time_slots = JSON.parse(role.time_slots);
          }catch(err){
            this.availableRoles[index].time_slots =  {
                      'monday':{
                        'is_checked':false,
                        'time':'',
                      },
                      'tuesday':{
                        'is_checked':false,
                        'time':''
                      },
                      'wednesday':{
                        'is_checked':false,
                        'time':''
                      },
                      'thursday':{
                        'is_checked':false,
                        'time':''
                      },
                      'friday':{
                        'is_checked':false,
                        'time':''
                      },
                      'saturday':{
                        'is_checked':false,
                        'time':''
                      },
                    };

          }


          })
          console.log(this.availableRoles)
        }).catch((err) => {
          if (err.response) {
            if (err.response.status == 404) {
              console.log("No Record Found");
              // this.noRecord = true;
              // this.isLoading = false;
            }
            if (err.response.status == 401) {
              this.logout();
            }
          }
        })


    },

    pushRoleId(event){
      let value = event.target.value;
      if(event.target.checked == true){
          this.role_ids.push( parseInt(value));

      }else{
        this.role_ids.forEach((role_id,index)=>{
          if(role_id == value){
            this.role_ids.splice(index,1);
          }
        })
      }
      console.log(this.role_ids);  
    },

    dateFormatter(value){
      return moment(value).format('MM/DD/YYYY');
    },
    showScheduleRequestModal(index){
      let role = this.assignedRoles[index];
      this.reScheduleRequestForm.role = role.role;
      this.reScheduleRequestForm.building = role.building;
      this.reScheduleRequestForm.location = role.location;
      this.reScheduleRequestForm.date = role.date;
      this.reScheduleRequestForm.time = role.start_time+' to '+role.end_time;
      this.$bvModal.show('scheduleRequestModal');

    },
  sendRequest(){
    Swal.fire({
      title: "Success!",
      text:"Request Sent!",
      icon: "success",
      width: 350,
      showConfirmButton: false,
      timer: 1500
    });

    this.$bvModal.hide('scheduleRequestModal');
  },
  sendRoleRequest(){

    
      if(this.requestformData.selectedSlots.length > 0 && this.requestformData.request_start_date != "" && this.requestformData.request_end_date != ""){

      // this.sendRoleRequestData.role_ids = this.role_ids;
      // this.sendRoleRequestData.user_id = this.userData.id;
      this.requestformData.user_id = this.userData.id;
      var config = {
            headers: {
              Authorization: 'Bearer ' + this.userData.token,
              'Accept': 'application/json'
            }
          };
        axios.post('sendrolerequest',this.requestformData,config).then(res =>{
           
          console.log(res.data); 
          if(res.status == 200){
                Swal.fire({
                  title: "Success!",
                  text:"Request has been Sent!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500
                });

                this.$bvModal.hide('sendRequestModal');
          }

        }).catch((err) => {
          if (err.response) {
            if (err.response.status == 404) {
              console.log("No Record Found");
              // this.noRecord = true;
              // this.isLoading = false;
            }
            if (err.response.status == 401) {
              this.logout();
            }
          }
        })

      }else{
        alert('please select start-date and end-date and one of the Available slots');
      }


  },
  showSendRequestModal(availableRole){
    this.requestformData = availableRole;
    this.requestformData.selectedSlots = []; 
    // console.log(this.requestformData);
    this.$bvModal.show('sendRequestModal');
  },
  setSelectedSlots(event,value){
    if(event.target.checked == true){
      this.requestformData.selectedSlots.push(value);
    }else{
      let index = this.requestformData.selectedSlots.indexOf(value);
      if (index > -1) {
        this.requestformData.selectedSlots.splice(index, 1);
      }

    }
    console.log(this.requestformData.selectedSlots);

  },
  gotoRoles(){
        router.push({ name: 'volunteer-roles'});
    },
    gotoMentorHours(){
        router.push({ name: 'mentor-hours'});
    },
    loginPage(){
        router.push({ name: 'login'});
    },
    gotoProfile(){
        router.push({ name: 'profile'});
    },
   gotoApplication(){
        router.push({ name: 'review-application'});
    }

  },
}
</script>

<template>
  <div>

    <!-- Modal Schedule Request START-->
                <b-modal
                    id="scheduleRequestModal"
                    centered
                    title="Reschedule Request"
                    title-class="font-18"
                    hide-footer
                >
                  <form >
                    <h5 class="mt-4 mb-4">{{reScheduleRequestForm.role}} at {{reScheduleRequestForm.building}} in {{reScheduleRequestForm.location}} at {{reScheduleRequestForm.time}} on {{reScheduleRequestForm.date}}</h5>
                    <div class="mb-3">
                      <label>Reason For Reschedule</label>
                      <div>
                          <textarea v-model="reScheduleRequestForm.comment"
                              class="form-control"
                              name="comment"
                              rows="3" placeholder="Enter Reason"
                                    :class="{
                            'is-invalid': typeSubmit && $v.reScheduleRequestForm.comment.$error,
                          }"
                          ></textarea>
                        <div
                            v-if="typeSubmit && $v.reScheduleRequestForm.comment.$error"
                            class="invalid-feedback"
                        >
                          <span v-if="!$v.reScheduleRequestForm.comment.required"
                          >Reason is required.</span
                          >
                        </div>
                      </div>
                    </div>

                    <div class="mb-5">
                      <div>
                        <button type="button" @click="sendRequest" class="btn btn-primary">Send Request</button>
                      </div>
                    </div>

                  </form>
                </b-modal>
    <!-- Modal Schedule Request END-->

    <!-- Modal Available Roles START-->
                <b-modal
                    id="sendRequestModal"
                    size="xl"
                    centered
                    title="Request Form"
                    title-class="font-18"
                    hide-footer
                >
                  <form >
                      <div class="row mt-5">
                        
                        <div class="mb-5 col-md-12">
                          <div>
                              <input v-model="requestformData.name" type="text" class="form-control" name="request_role" id="request_role">
                          
                          </div>
                          <small>Role</small>
                        </div>

                        <div class="mb-5 col-md-6">
                          <div>
                              <input v-model="requestformData.request_start_date" type="date" class="form-control" name="request_start_date" id="request_start_date">
                          </div>
                          <small>Select start Date</small>
                        </div>
                        <div class="mb-3 col-md-6">
                          <div>
                              <input v-model="requestformData.request_end_date" type="date" class="form-control" name="request_end_date" id="request_end_date">
                          </div>
                          <small>Select end Date</small>
                        </div>
                        <div class="mb-3 col-12">
                          <h4 class="mb-4">Select Time Slots</h4>

                          <div v-if="requestformData.time_slots.monday.is_checked" class="row align-items-center mb-3">
                            <div class="form-check">
                              <input @change="setSelectedSlots($event,'Monday '+requestformData.time_slots.monday.time)"  class="form-check-input" type="checkbox" id="monday"/>
                              <label class="" for="monday">Monday {{ requestformData.time_slots.monday.time }}</label>  
                            </div>
                          </div>


                          <div v-if="requestformData.time_slots.tuesday.is_checked" class="row align-items-center mb-3">
                            <div class="form-check">
                              <input @change="setSelectedSlots($event,'Tuesday '+requestformData.time_slots.tuesday.time)" class="form-check-input" type="checkbox" id="tuesday"/>
                              <label class="" for="tuesday">Tuesday {{ requestformData.time_slots.tuesday.time }}</label>  
                            </div>
                          </div>

                          <div v-if="requestformData.time_slots.wednesday.is_checked" class="row align-items-center mb-3">
                            <div class="form-check">
                              <input @change="setSelectedSlots($event,'Wednesday '+requestformData.time_slots.wednesday.time)" class="form-check-input" type="checkbox" id="wednesday"/>
                              <label class="" for="wednesday">Wednesday {{ requestformData.time_slots.wednesday.time }}</label>  
                            </div>
                          </div>

                          <div v-if="requestformData.time_slots.thursday.is_checked" class="row align-items-center mb-3">
                            <div class="form-check">
                              <input @change="setSelectedSlots($event,'Thursday '+requestformData.time_slots.thursday.time)" class="form-check-input" type="checkbox" id="thursday"/>
                              <label class="" for="thursday"> Thursday {{ requestformData.time_slots.thursday.time }}</label>  
                            </div>
                          </div>

                          <div v-if="requestformData.time_slots.friday.is_checked" class="row align-items-center mb-3">
                            <div class="form-check">
                              <input @change="setSelectedSlots($event,'Friday '+requestformData.time_slots.friday.time)" class="form-check-input" type="checkbox" id="friday"/>
                              <label class="" for="friday"> Friday {{ requestformData.time_slots.friday.time }}</label>  
                            </div>
                          </div>

                          <div v-if="requestformData.time_slots.saturday.is_checked" class="row align-items-center mb-3">
                            <div class="form-check">
                              <input @change="setSelectedSlots($event,'Saturday '+requestformData.time_slots.saturday.time)" class="form-check-input" type="checkbox" id="saturday"/>
                              <label class="" for="saturday"> Saturday {{ requestformData.time_slots.saturday.time }}</label>  
                            </div>
                          </div>

                        </div>


                        <!-- <div class="mb-5 col-md-2">
                          <h4>Available Time slots</h4>
                          
                          <div>

                            availableRoles
                              <input type="date" v-model="roleFilterForm.start_date" class="form-control">
                          </div>
                          <small>Start Date</small>

                        </div> -->


                        <!-- <div class="mb-5 col-md-2">
                          <div>
                              <input type="date" v-model="roleFilterForm.end_date" class="form-control">
                          </div>
                          <small>End Date</small>

                        </div> -->

                        <div class="col-md-12">
                          <div class="mb-5">
                            <div>
                              <button type="button" @click="sendRoleRequest()" class="btn btn-primary">Send Request</button>
                            </div>
                          </div>
                        </div>


                      </div><!--row end-->

                  </form>

                </b-modal>


    <Header></Header>
    <div id="main-title" class="secondary">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6 align-self-center">
            <h3 class="title"> Schedule Roles</h3>
          </div>
          <div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
            <p class="need-help">Need Help ? <a href="javascript:">Contact Us</a> </p>
            <!-- <logout-button></logout-button> -->
          </div>
        </div>
      </div>
    </div>


    <div class="custom-form d-flex container pb-5 pt-5">
            <b-button class="btn-custom ms-0"  variant="custom" @click="gotoProfile">
                  Profile Information
            </b-button>
            <b-button v-if="userData['user_type_id'] === 4" class="btn-custom"  variant="custom" @click="gotoRoles">
                  Roles
            </b-button>
            <b-button v-else class="btn-custom"  variant="custom" @click="gotoMentorHours">
                  Mentor Hours
            </b-button>
            <b-button class="btn-custom"  variant="custom" v-if="(contactInfoForm.status !== 1)" @click="gotoApplication">
                  Review Application
            </b-button>


    </div>    
    <!-- main content -->
    <div class="card custom-form pt-3 pb-3 container" v-if="userId">
      <div class="card-body">

        <!-- <div class="card-heade">
            <button type="button" class="btn btn-primary"  variant="custom"  @click="showAvailableRolesModal()">
                  View Available Roles
            </button>

        </div> -->

              <div class="row mt-3">

                <div class="col-md-12 px-0 cards-cont">

                    <!-- <form >
                      <div class="row mt-5">
                        
                        <div class="mb-5 col-md-3">
                          <div>
                              <b-form-select class="form-select" v-model="roleFilterForm.category_id"
                                            :options="categories">
                                <option slot="first" :value="null">Select Category</option>
                              </b-form-select>
                              <small>Select Category</small>
                          
                          </div>
                        </div>

                        <div class="mb-5 col-md-3">
                          <div>
                              <b-form-select class="form-select" v-model="roleFilterForm.role_id"
                                            :options="roles">
                                <option slot="first" :value="null">Select Role</option>
                              </b-form-select>
                          </div>
                          <small>Select Role</small>
                        </div>


                        <div class="mb-5 col-md-2">
                          <div>
                              <input type="date" v-model="roleFilterForm.start_date" class="form-control">
                          </div>
                          <small>Start Date</small>

                        </div>


                        <div class="mb-5 col-md-2">
                          <div>
                              <input type="date" v-model="roleFilterForm.end_date" class="form-control">
                          </div>
                          <small>End Date</small>

                        </div>

                        <div class="col-md-2">
                          <div class="mb-5">
                            <div>
                              <button type="button" @click="filterAvailableRoles()" class="btn btn-primary">Search Options</button>
                            </div>
                          </div>
                        </div>


                      </div>

                  </form> -->


                  <div class="table-responsive">
                            <table class="table table-bordered table-hover table-striped align-middle">
                              

                              <thead >

                                <tr>
                                  <th>Role</th>
                                  <!-- <th>Date</th> -->
                                  <!-- <th>Time Slots</th> -->
                                  <th>Request</th>
                                </tr>

                              </thead>


                              <tbody>

                              <tr v-for="(availableRole, index) in this.availableRoles" :key="index">
                                <td>
                                  {{availableRole.name}}
                                </td>
                                <!-- <td>
                                  {{dateFormatter(availableRole.created_at)}}
                                </td> -->
                                <!-- <td>
                                  {{availableRole.time_slots}}
                                </td> -->
                                <td>
                                    <button type="button" class="btn btn-primary"  variant="custom"  @click="showSendRequestModal(availableRole)">
                                      Send Request
                                    </button>

                                  <!-- <input type="checkbox" :value="availableRole.id" @change="pushRoleId($event)"> -->
                                </td>

                              </tr>

                              </tbody>
                            </table>

                        <!-- <div class="mb-5">
                          <div>
                            <button type="button" @click="sendRoleRequest()" class="btn btn-primary">Send Request</button>
                          </div>
                        </div> -->

                  </div>



                </div>
              </div>

      </div>
    </div>

    <div class="custom-form" v-else>

            <div class="text-center mt-3">
                <b-button class="btn-custom"  variant="custom" @click="loginPage">
                  Login
                </b-button>
              </div>

    </div>

    <Footer></Footer>
  </div>
</template>
<style scoped>
.btn.btn-primary{
  background: #d0885a!important;
  border: 1px solid #d0885a!important;
}
.custom-form label{
  font-size: 16px;
  margin-left: 16px;
}
.media:hover .edit-box{
  position:absolute;
  top:0px;
  bottom:0px;
  left:0px;
  right:0px;
  visibility:visible;
  opacity:1;
}
.media .edit-box{
  visibility:hidden;
  opacity:0;
  display:flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(0 0 0 / 0.08);
}
.roles-boxes {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.box {
  padding: 5px;
  text-align: center;
}
.box.mentor{
  border:2px solid #556ee6;
}
.box.donor{
  border:2px solid #34c38f;
}
.box.p-alum{
  border:2px solid #50a5f1;
}
.box.volunteer{
  border:2px solid #f1b44c;
}
.chck-icon{
  font-size:130px;
}
.pb-1-5rem{
  padding-bottom:1.5rem !important;
}
.avatar-box{
  width:30%;
  overflow: hidden;
  margin: 0 auto;
}
.img-wrap{
  height: 7.5rem;
  width: 7.5rem;
  position:relative;
  border: 2px solid #f6f6f6;
  border-radius:100%;
  overflow:hidden;
}
.img-wrap img{
  width:100%;
  position:absolute;
  left:0px;
  right:0px;
  top:50%;
  transform:translateY(-50%);
}
.preview{
  position:relative;
}
.preview img{
  width:100%;
}
.btn-remove{
  background-color:#ebecec;
  position: absolute;
  top: -15px;
  right: -15px;
  padding: 0px;
  font-size: 24px;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  line-height: 30px;
  -webkit-box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
  box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
}
.form-check-input{
  margin-left: -6px;
  margin-right: 10px;
}
</style>
